import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

const Navbar = () => {
  return (
    <>
      <div className="w-full bg-red-  shadow-lg hidden md:block">
        <div className="md:w-10/12 lg:w-7/12 mx-auto bg-green- flex flex-row">

          {/* List */}
          <Link to="/" className="uppercase mr-6 py-2.5 text-sm font-semibold cursor-pointer border-b-4 border-blue-500">All</Link>
          <Link to="/blogs" className="uppercase mr-6 py-2.5 text-sm font-semibold cursor-pointer border-b-4 border-white hover:border-blue-500">Blogs 🔥</Link>
          <Link to="/blog" className="uppercase mr-6 py-2.5 text-sm font-semibold cursor-pointer border-b-4 border-white hover:border-blue-500">Blog</Link>
          <Link className="uppercase mr-6 py-2.5 text-sm font-semibold cursor-pointer border-b-4 border-blue-500">News</Link>
          <Link className="uppercase mr-6 py-2.5 text-sm font-semibold cursor-pointer border-b-4 border-white hover:border-blue-500">Fashion 🔥</Link>
          <Link className="uppercase mr-6 py-2.5 text-sm font-semibold cursor-pointer border-b-4 border-white hover:border-blue-500">Gadgets</Link>
          <Link className="uppercase mr-6 py-2.5 text-sm font-semibold cursor-pointer border-b-4 border-white hover:border-blue-500">Lifestyle</Link>
          <Link className="uppercase mr-6 py-2.5 text-sm font-semibold cursor-pointer border-b-4 border-white hover:border-blue-500">Video</Link>
          <Link className="uppercase mr-6 py-2.5 text-sm font-semibold cursor-pointer border-b-4 border-white hover:border-blue-500">Features</Link>
        </div>
      </div>
    </>
  );
}

export default Navbar;
